import { types } from 'framework/router/services/actions.js';
import reducerFactory from 'framework/router/services/reducer.js';

export default reducerFactory({ actionTypes: types });
